import { defineMessages } from 'react-intl'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import LineCameraPlusIcon from 'LuxKit/Icons/line/LineCameraPlusIcon'
import LineCoffeeIcon from 'LuxKit/Icons/line/LineCoffeeIcon'
import LineDrinksTrayIcon from 'LuxKit/Icons/line/LineDrinksTrayIcon'
import LineFootballBallIcon from 'LuxKit/Icons/line/LineFootballBallIcon'
import LineRestaurantIcon from 'LuxKit/Icons/line/LineRestaurantIcon'
import LineShoppingBagIcon from 'LuxKit/Icons/line/LineShoppingBagIcon'
import LineTicketIcon from 'LuxKit/Icons/line/LineTicketIcon'
import LineTreesIcon from 'LuxKit/Icons/line/LineTreesIcon'
import LineUniversityIcon from 'LuxKit/Icons/line/LineUniversityIcon'

const messages = defineMessages({
  hotels: {
    id: 'MwG32BL3QPDl-vFdl9aa',
    defaultMessage: 'Hotels',
    description: 'Explore category label for hotels on the trip planner map',
  },
  topAttractions: {
    id: 'E6p5kSMlqsK0qta2J3S-',
    defaultMessage: 'Top attractions',
    description: 'Explore category label for top attractions on the trip planner map',
  },
  restaurants: {
    id: 'dGN1D38X0F2rBTrqbPSj',
    defaultMessage: 'Restaurants',
    description: 'Explore category label for restaurants on the trip planner map',
  },
  cafes: {
    id: 'rvBdCRkwDuS4dyHef7GS',
    defaultMessage: 'Cafes',
    description: 'Explore category label for cafes on the trip planner map',
  },
  parks: {
    id: 'c_m0Qq-yd9laoUDZtEzo',
    defaultMessage: 'Parks',
    description: 'Explore category label for parks on the trip planner map',
  },
  shopping: {
    id: 'lWAJI_T8cadoJg486ZmZ',
    defaultMessage: 'Shopping',
    description: 'Explore category label for shopping on the trip planner map',
  },
  museums: {
    id: 'v83i7kN65Qqvj4P-d1E9',
    defaultMessage: 'Museums',
    description: 'Explore category label for museums on the trip planner map',
  },
  bars: {
    id: 'KPu8gCTx6Jtl_9qUEdSs',
    defaultMessage: 'Bars',
    description: 'Explore category label for bars on the trip planner map',
  },
  sports: {
    id: '1lkPhgjBZlVSBGojWO9R',
    defaultMessage: 'Sports',
    description: 'Explore category label for sports on the trip planner map',
  },
  experiences: {
    id: 'nQtODE_HEKnifEaON7OD',
    defaultMessage: 'Experiences',
    description: 'Explore category label for experiences on the trip planner map',
  },
})

export type ChatExploreCategoryKey =
  | 'hotels'
  | 'experiences'
  | 'top-attractions'
  | 'restaurants'
  | 'cafes'
  | 'parks'
  | 'shopping'
  | 'museums'
  | 'bars'
  | 'sports'

export const chatExploreCategories = [
  {
    key: 'hotels' as const,
    label: 'Hotels',
    labelMessage: messages.hotels,
    icon: LineBedIcon,
    source: 'le-hotels' as const,
  },
  {
    key: 'experiences' as const,
    label: 'Experiences',
    labelMessage: messages.experiences,
    icon: LineTicketIcon,
    source: 'le-experiences' as const,
  },
  {
    key: 'top-attractions' as const,
    label: 'Top attractions',
    labelMessage: messages.topAttractions,
    icon: LineCameraPlusIcon,
    source: 'google-places' as const,
  },
  {
    key: 'restaurants' as const,
    label: 'Restaurants',
    labelMessage: messages.restaurants,
    icon: LineRestaurantIcon,
    source: 'google-places' as const,
  },
  {
    key: 'cafes' as const,
    label: 'Cafes',
    labelMessage: messages.cafes,
    icon: LineCoffeeIcon,
    source: 'google-places' as const,
  },
  {
    key: 'parks' as const,
    label: 'Parks',
    labelMessage: messages.parks,
    icon: LineTreesIcon,
    source: 'google-places' as const,
  },
  {
    key: 'shopping' as const,
    label: 'Shopping',
    labelMessage: messages.shopping,
    icon: LineShoppingBagIcon,
    source: 'google-places' as const,
  },
  {
    key: 'museums' as const,
    label: 'Museums',
    labelMessage: messages.museums,
    icon: LineUniversityIcon,
    source: 'google-places' as const,
  },
  {
    key: 'bars' as const,
    label: 'Bars',
    labelMessage: messages.bars,
    icon: LineDrinksTrayIcon,
    source: 'google-places' as const,
  },
  {
    key: 'sports' as const,
    label: 'Sports',
    labelMessage: messages.sports,
    icon: LineFootballBallIcon,
    source: 'google-places' as const,
  },
] as const

export type ChatExploreCategory = (typeof chatExploreCategories)[number]

export type ChatExploreCategorySource = ChatExploreCategory['source']
export type LEExploreCategorySource = Extract<ChatExploreCategorySource, 'le-hotels' | 'le-experiences'>
